import { faEye, faPaperPlane, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import React from 'react'
import { ActivityIndicator, TouchableOpacity, View } from 'react-native'
import { disabledGray, toqueColor } from '../../../theme/colors'
import { Separator } from '../../../components/Separator'

interface Props {
  onPressDelete: () => void
  onPressShow: () => void
  onPressSend: () => void
  sendingLoader: boolean
  numberOfSelectedRecords: number
}

export const HeaderList = ({
  onPressDelete,
  onPressSend,
  onPressShow,
  sendingLoader,
  numberOfSelectedRecords,
}: Props) => {
  return (
    <View style={{ marginLeft: 'auto', flexDirection: 'row' }}>
      <TouchableOpacity
        style={{ padding: 10 }}
        disabled={numberOfSelectedRecords > 1 || numberOfSelectedRecords === 0}
        onPress={onPressShow}
      >
        <FontAwesomeIcon
          icon={faEye}
          size={20}
          color={
            numberOfSelectedRecords > 1 || numberOfSelectedRecords === 0 ? disabledGray : toqueColor
          }
        />
      </TouchableOpacity>
      <TouchableOpacity
        style={{ padding: 10 }}
        onPress={onPressDelete}
        disabled={numberOfSelectedRecords === 0}
      >
        <FontAwesomeIcon
          icon={faTrashAlt}
          size={20}
          color={numberOfSelectedRecords === 0 ? disabledGray : toqueColor}
        />
      </TouchableOpacity>
      <TouchableOpacity
        style={{ padding: 10 }}
        onPress={onPressSend}
        disabled={numberOfSelectedRecords === 0}
      >
        {sendingLoader && <ActivityIndicator size='small' color={toqueColor} />}
        {!sendingLoader && (
          <FontAwesomeIcon
            icon={faPaperPlane}
            size={20}
            color={numberOfSelectedRecords === 0 ? disabledGray : toqueColor}
          />
        )}
      </TouchableOpacity>
      <Separator />
    </View>
  )
}
